var _rect, _rect2, _circle, _path, _text, _path2, _defs, _rect3, _circle2, _circle3, _circle4, _path3, _text2, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartoonifyImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cartoonGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a4d3d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d6f5f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#cartoonGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 120,
    height: 120,
    rx: 8,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 20,
    fill: "#999",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60 110 Q 85 95 110 110",
    stroke: "#999",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 185,
    fontSize: 11,
    fill: "#999",
    textAnchor: "middle"
  }, "Original")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 110 L 195 110 L 190 105 M 195 110 L 190 115",
    stroke: "#00ff88",
    strokeWidth: 3,
    fill: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3, 0 6",
    fill: "#00ff88"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 50,
    width: 120,
    height: 120,
    rx: 8,
    fill: "none",
    stroke: "#ff9d3d",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 85,
    r: 20,
    fill: "none",
    stroke: "#ff9d3d",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 80,
    r: 4,
    fill: "#ff9d3d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 80,
    r: 4,
    fill: "#ff9d3d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 270 95 Q 285 105 300 95",
    stroke: "#ff9d3d",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 185,
    fontSize: 11,
    fill: "#ff9d3d",
    textAnchor: "middle"
  }, "Cartoon")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 230,
    r: 8,
    fill: "#ff9d3d",
    opacity: 0.4
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 270,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#ff9d3d"
  }, "Edge Detection \u2022 Color Quantization \u2022 Smoothing")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoonifyImage);
export default __webpack_public_path__ + "static/media/cartoonify_image.6f753bcd3f15ba959704a8dc9710041c.svg";
export { ForwardRef as ReactComponent };